import {Input} from '@mantine/core';
import {Box} from 'src/design/atoms/Box';
import React from 'react';
import {Controller, useFormContext} from 'react-hook-form';
import {SectionCard} from 'src/design/atoms/SectionCard';
import type {InstanceFormValues, InstanceSectionProps} from './SectionProps';

export const GeneralSection: React.FC<InstanceSectionProps> = ({mode}) => {
  const {control} = useFormContext<InstanceFormValues>();

  // In view mode, the instance name is already displayed in the PageHeader title
  if (mode === 'view') {
    return null;
  }

  return (
    <SectionCard title="General" data-testid="section-general">
      <Box p="md" maw={500}>
        <Controller
          name="name"
          control={control}
          render={({field, fieldState}) => (
            <Input.Wrapper
              data-testid="form-field-name"
              label="Instance Name"
              description="A unique name to identify this workspace."
              error={fieldState.error?.message}
              withAsterisk>
              <Input
                data-testid="form-field-name-input"
                value={field.value || ''}
                onChange={field.onChange}
                onBlur={field.onBlur}
                name={field.name}
                placeholder="Enter instance name"
                error={!!fieldState.error}
                autoComplete="new-password"
              />
            </Input.Wrapper>
          )}
        />
      </Box>
    </SectionCard>
  );
};
